  import React, { useEffect } from 'react'
import _ from 'lodash'

import ScreenLoading from 'components/ScreenLoading'
import { Redirect } from 'components/Redirect'

import useGetOrganizations from 'containers/organizations/useGetOrganizations'
import usePageTitle from 'containers/pageTitle/usePageTitle'
import {useHistory} from "react-router"

const Home = () => {
  const {
    organizationsError,
    getOrganizations,
    organizations,
    loadingOrganizations,
  } = useGetOrganizations()

  const history = useHistory()

  //Page title
  usePageTitle('Maya')


  const getData = async () => {
    getOrganizations()
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [])

  if (loadingOrganizations) {
    return <ScreenLoading />
  }

  if (!organizations || organizationsError) {
    return <>There was an issue loading your organizations</>
  }

  if (organizations && organizations.length === 1) {
    return <Redirect to={'/create-organization'} />
  }

  let organization = null
  if (localStorage.getItem('currentOrganization')) {
    organization = _.find(organizations, [
      'slug',
      localStorage.getItem('currentOrganization'),
    ])
  }
  if (!organization) {
    organization = organizations[0]
  }

  // NOTE: Home deliberately does NOT resume a stored Shopify onboarding. After a merchant
  // cancels on admin.shopify.com they land back here, indistinguishable from an interrupted
  // connect — an ambient resume would re-drive them into Shopify connect against their intent
  // (and once looped, forever). Every legitimate resume has its own intent-bound trigger:
  // arriving on /shopify-integration (fresh install / reopen from Shopify), sign-in return_to,
  // and CreateOrganization's post-create resume.

  // New users without dashboard should go to sources to add integrations
  history.push({pathname: `/organization/${organization.slug}/sources`})
  return <></>
}

export default React.memo(Home)
